import React, { useCallback } from 'react';
import { Box } from '@material-ui/core';
import { VirtualizedList, CardListWidget, InfiniteScroller } from '..';
import { Experience } from 'types';
import Item from './Item';

type Props = {
  experiences: Experience[];
  loading?: boolean;
  loadMore?: () => void;
  totalResults?: number;
  page?: number;
};

const ExperiencesList: React.FC<Props> = ({
  experiences,
  loading,
  loadMore,
  totalResults,
  page,
}) => {
  const renderItem = useCallback((experience: Experience) => <Item experience={experience} />, []);

  if (loading) {
    return (
      <Box marginTop={3}>
        <VirtualizedList
          data={new Array(3).fill(true)}
          renderItem={() => <CardListWidget.Skeleton withLogo withActions />}
        />
      </Box>
    );
  }
  return (
    <Box marginTop={3}>
      {loadMore && totalResults && page !== undefined ? (
        <InfiniteScroller
          data={experiences}
          renderItem={renderItem}
          loadMore={loadMore}
          totalResults={totalResults}
          page={page}
        />
      ) : (
        <VirtualizedList data={experiences} renderItem={renderItem} />
      )}
    </Box>
  );
};

ExperiencesList.displayName = 'ExperiencesList';

export default React.memo(ExperiencesList);
